// extracted by mini-css-extract-plugin
module.exports = {"link":"_6f25b66c20--link--1Yo6F","orange":"_6f25b66c20--orange--2QiOH"};